import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "job-options-dropdown" }
const _hoisted_2 = {
  key: 3,
  class: "job-options-dropdown__divider"
}
const _hoisted_3 = {
  key: 10,
  class: "job-options-dropdown__divider"
}

import {computed, ref} from "vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import {Job} from "@/store/jobs";
import {useRoute, useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'JobsOptionsDropdown',
  props: {
    job: {},
    showSendToChecking: { type: Boolean },
    showEndByWorker: { type: Boolean },
    showEndByWorkerWithMessage: { type: Boolean },
    showEndByCreator: { type: Boolean },
    showSendToReworking: { type: Boolean },
    showEndByAdmin: { type: Boolean },
    showEdit: { type: Boolean },
    showDelete: { type: Boolean }
  },
  emits: ["on-share", "on-show-info", "on-edit", "on-delete", "on-create-linked", "on-show-linked", "on-comment", "on-send-to-checking", "on-end-by-worker", "on-end-by-worker-with-message", "on-end-by-creator", "on-send-to-reworking", "on-end-by-admin"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

// Верхняя секция (связанные работы, комментировать)
const hasTopActions = computed(() => false)

// Видимость разделителя между статус-действиями и остальным меню
const hasStatusActions = computed(() =>
	props.showSendToReworking
	|| props.showEndByWorker
	|| props.showEndByCreator
	|| props.showEndByWorkerWithMessage
	|| props.showEndByAdmin
	|| props.showSendToChecking
)

const $tooltip = ref<typeof AppTooltip | null>(null)
const router = useRouter()
const route = useRoute()

const onCopyLink = () => {
	const textArea = document.createElement('textarea');

	let link;
	if (props.job.Project) {
		const { href } = router.resolve({
			query: {
				page: 'project',
				id: props.job.Project.Id,
				jobId: props.job.Id,
			}
		})
		link = href
	} else {
		const { href } = router.resolve({
			query: {
				page: 'client',
				id: props.job.Clients[0].Id,
				jobId: props.job.Id,
			}
		})
		link = href
	}

	textArea.value = window.location.origin + link;
	textArea.style.position = 'fixed';
	textArea.style.left = '-999999px';
	textArea.style.top = '-999999px';
	document.body.appendChild(textArea);

	textArea.focus();
	textArea.select();

	try {
		document.execCommand('copy');
	} catch (err) {
		console.error('Не удалось скопировать текст: ', err);
	}

	document.body.removeChild(textArea);
	$tooltip.value?.showByClick()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    false
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "job-options-dropdown__item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('on-create-linked')))
        }, [
          _createVNode(AppIcon, {
            name: "create-related-work",
            width: "18px",
            color: "#979797"
          }),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "job-options-dropdown__item-text" }, "Создать связанную работу", -1))
        ]))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "job-options-dropdown__item",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('on-show-linked')))
        }, [
          _createVNode(AppIcon, {
            name: "related",
            width: "18px",
            color: "#979797"
          }),
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "job-options-dropdown__item-text" }, "Показать связанные работы", -1))
        ]))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "job-options-dropdown__item",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('on-comment')))
        }, [
          _createVNode(AppIcon, {
            name: "comment-arrow",
            width: "18px",
            color: "#979797"
          }),
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "job-options-dropdown__item-text" }, "Комментировать", -1))
        ]))
      : _createCommentVNode("", true),
    (hasTopActions.value && hasStatusActions.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.showSendToReworking)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "job-options-dropdown__item job-options-dropdown__item--warning",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('on-send-to-reworking')))
        }, [
          _createVNode(AppIcon, {
            name: "back-to-rework",
            width: "18px",
            color: "#979797"
          }),
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "job-options-dropdown__item-text" }, "Вернуть на доработку", -1))
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEndByWorker)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "job-options-dropdown__item",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('on-end-by-worker')))
        }, [
          _createVNode(AppIcon, {
            name: "check-circle",
            width: "18px",
            color: "#979797"
          }),
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "job-options-dropdown__item-text" }, "Завершить работу", -1))
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEndByCreator)
      ? (_openBlock(), _createElementBlock("div", {
          key: 6,
          class: "job-options-dropdown__item",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('on-end-by-creator')))
        }, [
          _createVNode(AppIcon, {
            name: "check-circle",
            width: "18px",
            color: "#979797"
          }),
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "job-options-dropdown__item-text" }, "Принять работу", -1))
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEndByWorkerWithMessage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 7,
          class: "job-options-dropdown__item",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('on-end-by-worker-with-message')))
        }, [
          _createVNode(AppIcon, {
            name: "check-circle",
            width: "18px",
            color: "#979797"
          }),
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "job-options-dropdown__item-text" }, "Завершить с отчётом", -1))
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEndByAdmin)
      ? (_openBlock(), _createElementBlock("div", {
          key: 8,
          class: "job-options-dropdown__item",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (emit('on-end-by-admin')))
        }, [
          _createVNode(AppIcon, {
            name: "end-by-admin",
            width: "18px",
            color: "#979797"
          }),
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "job-options-dropdown__item-text" }, "Завершить как администратор", -1))
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSendToChecking)
      ? (_openBlock(), _createElementBlock("div", {
          key: 9,
          class: "job-options-dropdown__item job-options-dropdown__item--warning",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (emit('on-send-to-checking')))
        }, [
          _createVNode(AppIcon, {
            name: "send-to-check",
            width: "18px",
            color: "#979797"
          }),
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "job-options-dropdown__item-text" }, "Отправить на проверку", -1))
        ]))
      : _createCommentVNode("", true),
    (hasStatusActions.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : _createCommentVNode("", true),
    _createVNode(AppTooltip, {
      ref_key: "$tooltip",
      ref: $tooltip,
      class: "job-options-dropdown__share-tooltip",
      text: "Ссылка скопирована в буфер",
      position: "right",
      "show-by-activator-click": ""
    }, {
      activator: _withCtx(() => [
        _createElementVNode("div", {
          class: "job-options-dropdown__item",
          onClick: onCopyLink
        }, [
          _createVNode(AppIcon, {
            name: "share",
            width: "18px",
            color: "#979797"
          }),
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "job-options-dropdown__item-text" }, " Поделиться ссылкой ", -1))
        ])
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", {
      class: "job-options-dropdown__item",
      onClick: _cache[9] || (_cache[9] = ($event: any) => (emit('on-show-info')))
    }, [
      _createVNode(AppIcon, {
        name: "info-circle-outline",
        width: "18px",
        color: "#979797"
      }),
      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "job-options-dropdown__item-text" }, " Посмотреть информацию ", -1))
    ]),
    (_ctx.showEdit)
      ? (_openBlock(), _createElementBlock("div", {
          key: 11,
          class: "job-options-dropdown__item",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (emit('on-edit')))
        }, [
          _createVNode(AppIcon, {
            name: "edit-square-outline",
            width: "18px",
            color: "#979797"
          }),
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "job-options-dropdown__item-text" }, " Редактировать работу ", -1))
        ]))
      : _createCommentVNode("", true),
    (_ctx.showDelete)
      ? (_openBlock(), _createElementBlock("div", {
          key: 12,
          class: "job-options-dropdown__item",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (emit('on-delete')))
        }, [
          _createVNode(AppIcon, {
            name: "delete-outline",
            width: "18px",
            color: "#979797"
          }),
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "job-options-dropdown__item-text" }, " Удалить работу ", -1))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})